import styles from './Align.module.scss';
import clsx from 'clsx';
import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  horizontal?: 'start' | 'center' | 'end';
  vertical?: 'top' | 'middle' | 'bottom';
}

export function Align({
  children,
  horizontal = 'start',
  vertical = 'top',
}: Props) {
  return (
    <div
      className={clsx(styles['align'], styles[horizontal], styles[vertical])}
    >
      {children}
    </div>
  );
}
